import _ from 'lodash'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import styles from './index.css'

import Editor from '../../Common/ProposalForm/Editor/Editor'
import Video from '../../Common/ProposalForm/Video/Video'
import { ProposalBlock, ProposalSection } from '@vzmi/shp_shared_compo'
import { FormValueSelector } from '../../../Common/forms'
import { isNewListingProposal, isNewProductProposal } from '../../../../../lib/proposalHelper'
import { When } from '../../../Common/Form'
import Warranty from './Warranty'
import { WARRANTY_SECTION_NAME } from '../../../../constants/proposalTypes'
import { WARRANTY_FIELD } from '../../Shared'
import Tip from '../../Common/Tip'
import { getFormValues } from '../../Common/ProposalForm/Shared/util'
import usePageFlow from '../../../BatchProposal/hook/usePageFlow'

const EditorBlock = props => {
  const { readOnly, shipType, isCloneListing, copy, isEditPage, isNewListing, isNewProduct } = props
  return (
    <ProposalBlock>
      <Editor
        readOnly={readOnly}
        shipType={shipType}
        isCloneListing={isCloneListing}
        copy={copy}
        isEditPage={isEditPage}
        isNewListing={isNewListing}
        isNewProduct={isNewProduct}
      />
    </ProposalBlock>
  )
}

const Media = props => {
  const {
    proposalType,
    user,
    flags,
    fromClone,
    change,
    match,
    reduxFormState,
    pageFlow: { currentFlow }
  } = props
  const isNewProposal = !fromClone
  const isNewListing = isNewListingProposal(proposalType)
  const isNewProduct = isNewProductProposal(proposalType)
  const isCloneListing = _.get(match, 'params.feature') === PROPOSAL_TYPE.CLONE_LISTING
  const phase = _.get(match, 'params.phase')
  const formValues = getFormValues(reduxFormState)
  // 取得當前賣場詳情資料
  const copy = _.get(formValues, 'product.copy', '')
  // 判斷為修改頁
  const { isEditPage } = usePageFlow(phase, currentFlow)
  return (
    <FormValueSelector
      selector={
        select => ({
          readOnly: select('setting.readOnly'),
          shipType: select('product.shipType'),
          isWarrantyEmpty: select('product.isWarrantyEmpty')
        })
      }
    >
      {
        values => {
          const { readOnly, shipType, isWarrantyEmpty } = values
          return (
            <div data-role='proposal-media'>
              <When
                value={isNewListing}
                isTrue
              >
                <ProposalBlock>
                  <Video
                    readOnly={readOnly}
                  />
                </ProposalBlock>
              </When>
              {
                isNewListing
                  ? (
                    <ProposalSection
                      className={styles.copySection}
                      title='商品詳情'
                    >
                      <EditorBlock
                        readOnly={readOnly}
                        shipType={shipType}
                        isCloneListing={isCloneListing}
                        copy={copy}
                        isEditPage={isEditPage}
                        isNewListing={isNewListing}
                      />
                    </ProposalSection>
                  )
                  : (
                    <EditorBlock
                      readOnly={readOnly}
                      shipType={shipType}
                      copy={copy}
                      isEditPage={isEditPage}
                      isNewProduct={isNewProduct}
                    />
                  )
              }
              <ProposalSection
                title={WARRANTY_SECTION_NAME}
                description={
                  isWarrantyEmpty
                    ? <Tip type='important'>商品保證資訊已遺失</Tip>
                    : null
                }
              >
                <ProposalBlock>
                  <Warranty
                    fieldName={WARRANTY_FIELD}
                    triggerFieldChange={change}
                    flags={flags}
                    user={user}
                    isNewProposal={isNewProposal}
                    readOnly={readOnly}
                  />
                </ProposalBlock>
              </ProposalSection>
            </div>
          )
        }
      }
    </FormValueSelector>
  )
}

export default Media
